import { render, staticRenderFns } from "./tag-group-config.vue?vue&type=template&id=bb30d264&scoped=true"
import script from "./tag-group-config.vue?vue&type=script&lang=js"
export * from "./tag-group-config.vue?vue&type=script&lang=js"
import style0 from "./tag-group-config.vue?vue&type=style&index=0&id=bb30d264&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb30d264",
  null
  
)

export default component.exports